import { render } from "./DemoTerms.vue?vue&type=template&id=c8c77650"
import script from "./DemoTerms.vue?vue&type=script&lang=js"
export * from "./DemoTerms.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__